/* HomeLens Brand Logo Component */
import { memo } from "react";

export const HomeLensLogo = memo(({ size = "default", className = "" }) => {
  const sizes = {
    sm: { icon: 22, text: "text-sm", gap: "gap-1.5" },
    default: { icon: 26, text: "text-lg", gap: "gap-2" },
    lg: { icon: 32, text: "text-xl", gap: "gap-2.5" },
  };

  const s = sizes[size] || sizes.default;

  return (
    <div className={`flex items-center ${s.gap} ${className}`} data-testid="homelens-logo">
      <svg width={s.icon} height={s.icon} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Lens circle */}
        <circle cx="14" cy="14" r="11" stroke="currentColor" strokeWidth="2.2" className="text-primary" fill="none" />
        {/* House inside lens */}
        <path d="M14 8L8 13V19H11V15H17V19H20V13L14 8Z" fill="currentColor" className="text-primary" />
        {/* Focus handle */}
        <line x1="22" y1="22" x2="29" y2="29" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" className="text-primary" />
      </svg>
      <span className={`font-heading font-bold ${s.text} text-foreground tracking-tight`}>
        Home<span className="text-primary">Lens</span>
      </span>
    </div>
  );
});

HomeLensLogo.displayName = "HomeLensLogo";
